import styled from "styled-components";

export const ContactSection = styled.section`
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 16px;
  padding: 80px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  background: #101015;
  color: #fff;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 48px 24px;
    gap: 40px;
  }
`;

export const ContactInfo = styled.div`
  h2 {
    color: #fff;
    font-family: 'Playfair Display', serif;
    font-size: 42px;
    line-height: 1.2;
    
    @media (max-width: 768px) {
      font-size: 32px;
      margin-bottom: 32px;
    }
  }

  /* Equal spacing between the three ContactItem sections */
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContactRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const ContactColumn = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 12px 0; /* Removed top margin */
    font-family: 'Inter', sans-serif;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin: 4px 0;
    font-size: 16px;
  }
`;

export const ContactItem = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 16px 0; /* Explicitly remove top margin */
    font-family: 'Inter', sans-serif;
  }
`;

export const OfficeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const OfficeColumn = styled.div`
  strong {
    color: #fff;
    font-weight: 600;
    display: block;
    margin: 0 0 8px 0; /* Removed top margin */
    font-size: 16px;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin: 4px 0;
    font-size: 16px;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
`;

export const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }
`;

export const FormContainer = styled.div`
  /* Add any desired form container styles here */
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const NameFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.5px;
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: none;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const TextArea = styled.textarea`
  padding: 12px 16px;
  border: none;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  resize: vertical;
  min-height: 120px;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const SubmitButton = styled.button`
  padding: 16px 24px;
  border: none;
  background: #fff;
  color: #000;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  border-radius: 999px;
  transition: all 0.3s ease;
  margin-top: 8px;
  
  &:hover {
    transform: translateY(-2px);
    background: #f5f5f5;
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1);
  }
`;